import moment from "moment";

export default {
    utcToLocal(dateString, timezone) {
        if( dateString )
        {
            var utcDate = moment(dateString);
            utcDate = moment.utc(moment(utcDate)).format()

            var localDate = moment.utc(utcDate).local();
            //var localDate2 = moment.tz(utcDate, timezone);

            return localDate;
        }

        return null;
    },
    humanize(minutes) {
        if( minutes )
        {
            const duration = moment.duration(minutes, 'minutes')

            return duration.humanize();
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./src/helpers.js